import axios from "axios";

// Shared look for the rig report / jobs / customers screens: same dark
// cyan theme as the rest of the app, phone-first sizing — every control
// >= 48px tall with 16px text (no iOS zoom-on-focus), one thumb, gloves.
export const cyan = "#00f5ff";
export const border = "rgba(0,245,255,0.15)";
export const card = "rgba(0,245,255,0.03)";
export const green = "#00cc66";
export const amber = "#ffaa00";
export const red = "#ff4466";

export const input = {
  width: "100%",
  minHeight: "48px",
  backgroundColor: "rgba(0,245,255,0.05)",
  border: "1px solid rgba(0,245,255,0.25)",
  borderRadius: "6px",
  padding: "10px 12px",
  color: "white",
  fontSize: "16px",
  outline: "none",
  boxSizing: "border-box",
  fontFamily: "'Segoe UI', sans-serif",
};

export const label = {
  color: cyan,
  fontSize: "12px",
  letterSpacing: "1px",
  textTransform: "uppercase",
  display: "block",
  marginBottom: "6px",
};

export const section = {
  backgroundColor: card,
  border: `1px solid ${border}`,
  borderRadius: "10px",
  padding: "16px",
  marginBottom: "14px",
};

export const sectionTitle = {
  color: cyan,
  fontSize: "13px",
  fontWeight: "700",
  letterSpacing: "2px",
  margin: "0 0 12px",
};

export const btn = {
  minHeight: "48px",
  padding: "0 16px",
  background: "none",
  border: "1px solid rgba(0,245,255,0.4)",
  color: cyan,
  borderRadius: "6px",
  fontSize: "15px",
  fontWeight: "700",
  cursor: "pointer",
};

export const btnPrimary = {
  ...btn,
  background: "linear-gradient(135deg, #00f5ff, #0080ff)",
  color: "#020817",
  border: "none",
};

export const btnDanger = { ...btn, border: `1px solid ${red}`, color: red };

export const page = {
  minHeight: "100vh",
  backgroundColor: "#020817",
  fontFamily: "'Segoe UI', sans-serif",
  color: "white",
};

export const grid2 = (isMobile) => ({
  display: "grid",
  gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
  gap: "12px",
});

export function todayKey() {
  const d = new Date();
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function addDays(dateKey, n) {
  const d = new Date(`${dateKey}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

export function money(n, lang) {
  if (n === null || n === undefined) return "—";
  return Number(n).toLocaleString(lang === "es" ? "es-US" : "en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
}

// Authenticated file download (PDF / CSV) — the API needs the bearer
// token, so a plain link won't do.
export async function downloadFile(url, token, fallbackName) {
  const res = await axios.get(url, { headers: { Authorization: "Bearer " + token }, responseType: "blob" });
  const cd = res.headers?.["content-disposition"] || "";
  const m = cd.match(/filename="?([^"]+)"?/);
  const name = m ? m[1] : fallbackName;
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
}

// Turns a blob error body (responseType "blob") back into its JSON message.
export async function blobError(err, fallback) {
  try {
    const text = await err.response.data.text();
    return JSON.parse(text).error || fallback;
  } catch {
    return err.response?.data?.error || fallback;
  }
}
